import React, { useEffect, useState } from "react"
import Loader from "./Loader"
import PermittedComponent from "PermittedComponent"
import { Container } from "reactstrap"
import { usePermissionData } from "AppContext"
import Breadcrumbs from "components/Common/Breadcrumb"
import { MdAdd, MdUpdate } from "react-icons/md"
import { axiosbaseurl } from "../config"
import { notification } from "antd"
import { SiTicktick } from "react-icons/si"
import { IoMdWarning } from "react-icons/io"

const MetaContent = () => {
  
   document.title = "Meta Title | Return First Investments"
  
  const [loading, setLoading] = useState(false)
  const [metaData, setMetaData] = useState([])
  const { checkAccess } = usePermissionData()

  const initialData = [
    { id: 1, page: "HomePage", path: "/", metaTitle: "", metaDescription: "" },
    {
      id: 2,
      page: "About Us",
      path: "/about-us",
      metaTitle: "",
      metaDescription: "",
    },
    {
      id: 3,
      page: "Contact Us",
      path: "/contact",
      metaTitle: "",
      metaDescription: "",
    },
    {
      id: 4,
      page: "Calculator",
      path: "/calculator",
      metaTitle: "",
      metaDescription: "",
    },
    {
      id: 5,
      page: "Financial Management",
      path: "/financial-management",
      metaTitle: "",
      metaDescription: "",
    },
    {
      id: 6,
      page: "Marketing",
      path: "/marketing",
      metaTitle: "",
      metaDescription: "",
    },
    {
      id: 7,
      page: "Business",
      path: "/business",
      metaTitle: "",
      metaDescription: "",
    },
    {
      id: 8,
      page: "Live Stock Assistance",
      path: "/stock-assitance",
      metaTitle: "",
      metaDescription: "",
    },
  ]

  useEffect(() => {
    getMetaData()
  }, [])

  async function getMetaData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`meta`)
      if (response?.data?.success) {
        setMetaData(
          JSON.parse(response?.data?.data?.[0]?.metaDetails) || initialData
        )
      }
    } catch (e) {
      console.log("Error", e.response.data.message)
    } finally {
      setLoading(false)
    }
  }

  const handleChange = (id, field, value) => {
    setMetaData(prev =>
      prev.map(item => (item.id === id ? { ...item, [field]: value } : item))
    )
  }

  const handleSubmit = async () => {
    setLoading(true)
    try {
      const response = await axiosbaseurl.put(`meta/1`, {
        metaDetails: JSON.stringify(metaData),
      })
      notification.open({
        message: (
          <div className="d-flex align-items-center">
            <div className="pr-20">
              <SiTicktick className="text-success fs-4 me-2" />
            </div>
            <div className="succes-message">
              Meta Content Updated Successfully.
            </div>
          </div>
        ),
        placement: "topRight",
      })
    } catch (error) {
      console.error("Update failed", error)
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pr-10">
              <IoMdWarning className="text-danger" size={22} />
            </div>
            <div>Opps! Something went wrong.</div>
          </div>
        ),
        description: error?.response?.data?.message,
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <React.Fragment>
      {loading && <Loader />}
      <PermittedComponent isAccess={checkAccess(8, 1)}>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="" breadcrumbItem="Meta Title and Description" />
            <div className="card p-3">
              <div className="d-flex flex-column flex-xl-row justify-content-end">
                <div>
                  {checkAccess(9, 3) && (
                    <button
                      className="btn btn-success rounded-pill px-4 mb-3 fs-6"
                      onClick={handleSubmit}
                    >
                      <MdUpdate className="me-2" />
                      Update All
                    </button>
                  )}
                </div>
              </div>
              {metaData.map(item => (
                <div key={item.id} className="meta-card mb-4">
                  <h5 className="fw-bold text-black mb-3">{item.page}</h5>
                  <div className="form-group">
                    <label>Meta Title</label>
                    <input
                      type="text"
                      className="form-control"
                      value={item.metaTitle}
                      onChange={e =>
                        handleChange(item.id, "metaTitle", e.target.value)
                      }
                    />
                  </div>
                  <div className="form-group mt-3">
                    <label>Meta Description</label>
                    <input
                      type="text"
                      className="form-control"
                      value={item.metaDescription}
                      onChange={e =>
                        handleChange(item.id, "metaDescription", e.target.value)
                      }
                    />
                  </div>
                </div>
              ))}
            </div>
          </Container>
        </div>
      </PermittedComponent>
    </React.Fragment>
  )
}

export default MetaContent
